import { SubscriptionModel } from "../../entities/billing";
import { BaseDataRepository } from "../BaseDataRepository";

export class SubscriptionRepo extends BaseDataRepository<SubscriptionModel>  {
  protected baseUrl = 'subscription';
}

export default SubscriptionRepo;
